export default __webpack_public_path__ + "static/Metropolis-SemiBoldItalic-d688084d9cb235670dafa1c6dec73e9b.woff2";